export interface IUserManagementDialogData {
    titleKey: string;
    descriptionKey: string;
    buttonTextKey: string;
    action: () => void;
    showCancel: boolean;
    icon?: string;
    currentState: string;
    newState: string;
    valueToReplace?: string;
}
